<script setup>
import BaseHeader from './components/BaseHeader.vue';
import BaseFooter from './components/BaseFooter.vue';

import { ref, computed, provide, onMounted } from "vue";
import debounce from "@/helpers/debounce"

const ANDROID_DETECT = /android/i;
const IOS_DETECT = /iPad|iPhone|iPod/;

const getOS = () => {
  const userAgent = navigator.userAgent || window.opera;
  if (ANDROID_DETECT.test(userAgent)) {
    return {
      url: "https://www.rustore.ru/catalog/app/ru.albank.online.aebit",
      name: "android",
    };
  }
  if (IOS_DETECT.test(userAgent) && !window.MSStream) {
    return {
      url: "https://apps.apple.com/ru/app/%D0%B0%D1%8D%D0%B1-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-2-0/id1278796871",
      name: "iOS",
    };
  }
  return null;
}

const getViewType = () => {
  const width = window.innerWidth
  if (width < 800) {
    return "mobile"
  } else if (width < 1200) {
    return "tablet"
  }
  return "desktop"
}

const getAppStoreUrl = computed(getOS) 
const isMobileOS = ref(getAppStoreUrl)

const viewType = ref(getViewType())

const updateViewType = () => {
  viewType.value = getViewType()
}

provide('isMobileOS', isMobileOS.value) 
provide('view', viewType)

onMounted(() => {
  window.addEventListener("resize", debounce(() => {
    updateViewType()
  }, 1000));
})
</script>

<template>
  <BaseHeader />
  <RouterView />
  <BaseFooter />
</template>
